import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import empty from '../empty.vue';
import { getDecorationList } from '../../api';
export default {
  name: 'saas_module_plate_nav',
  components: {
    empty: empty
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    styleId: [Number, String]
  },
  data: function data() {
    return {
      activeTab: '0'
    };
  },
  computed: {
    config: function config() {
      return this.value.config || {};
    },
    // 分类列表 右侧配置
    categoryList: function categoryList() {
      return this.config.value || [];
    },
    // 组件默认数据 板块及活动列表
    plateList: function plateList() {
      return this.value.default_value || [];
    },
    // 当前分类对应的活动列表 未设置分类时取首个板块
    activityList: function activityList() {
      var category = this.categoryList[Number(this.activeTab)];
      var plate = category ? this.plateList.find(function (i) {
        return String(i.module_plate_id) === String(category.module_plate_id);
      }) : this.plateList[0];
      var list = plate && plate.activity_list || [];
      var num = Number(this.config.activity_num);
      return num > 0 ? list.slice(0, num) : list;
    },
    Styles: function Styles() {
      var _this$config = this.config,
        _this$config$module_n = _this$config.module_name_font_size,
        module_name_font_size = _this$config$module_n === void 0 ? 28 : _this$config$module_n,
        _this$config$module_n2 = _this$config.module_name_font_color,
        module_name_font_color = _this$config$module_n2 === void 0 ? '#c20c0c' : _this$config$module_n2,
        _this$config$activity = _this$config.activity_name_font_size,
        activity_name_font_size = _this$config$activity === void 0 ? 28 : _this$config$activity,
        _this$config$activity2 = _this$config.activity_name_font_color,
        activity_name_font_color = _this$config$activity2 === void 0 ? '#333333' : _this$config$activity2;
      var baseSize = 32; //基准值 16*2 C端即可直接取值

      var moduleNameFontSize = module_name_font_size / baseSize;
      var activityNameFontSize = activity_name_font_size / baseSize;
      return {
        '--moduleNameFontSize': moduleNameFontSize + 'rem',
        '--moduleNameFontColor': module_name_font_color,
        '--activityNameFontSize': activityNameFontSize + 'rem',
        '--activityNameFontColor': activity_name_font_color
      };
    }
  },
  methods: {
    tabChange: function tabChange(_, e) {
      e.preventDefault();
      e.stopPropagation();
    },
    // 获取组件默认数据 拖拽至中心区域时展示对应活动图片
    loadData: function loadData() {
      var _this = this;
      var _this$$route$query = this.$route.query,
        _this$$route$query$te = _this$$route$query.temp_id,
        temp_id = _this$$route$query$te === void 0 ? '' : _this$$route$query$te,
        _this$$route$query$mo = _this$$route$query.mode,
        mode = _this$$route$query$mo === void 0 ? '' : _this$$route$query$mo;
      getDecorationList(_objectSpread(_objectSpread({
        key: this.value.key,
        style_id: this.styleId
      }, this.value.unique_id ? {
        unique_id: this.value.unique_id
      } : {}), {}, {
        is_template: temp_id && !['cur', 'new'].includes(temp_id) ? 1 : 0 //模版数据的 1 装修数据的传 0
      }), mode).then(function (res) {
        _this.$set(_this.value, 'default_value', res.data || []);
      });
    }
  },
  created: function created() {
    // 已有保存记录时再拉取默认数据；新增组件不请求接口
    if (this.value.unique_id) {
      this.loadData();
    }
  }
};